<header
    class="site-header"
    role="banner"
    (copy)="blockCopy()"
    (cut)="blockCut()"
>
    <livechat-widget
        [license]="'12112842'"
        [customerName]="visitor?.name"
        [customerEmail]="visitor?.email"
        [sessionVariables]="params"
        [visibility]="'minimized'"
        (onReady)="onWidgetReady($event)"
        (onAvailabilityChanged)="onAvailabilityChanged($event)"
    >
    </livechat-widget>

    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
    <div
        class="toolbar"
        *ngIf="!isAssessment && !isBadge"
    >
        <div class="page-width toolbar__inner-wrap">
            <button
                *ngIf="username"
                (click)="toggleMobileMenu()"
                [class.icon--close]="isMenuOpen"
                [class.icon--menu]="!isMenuOpen"
                class="primary-nav-toggle button button--bare button--icon icon"
            >
                <span class="is-vishidden">Menu</span>
            </button>
            <div class="contact">
                <a
                    href="https://twitter.com/NBRC_tweets"
                    class="fa fa-twitter"
                    target="_blank"
                ></a>
                <a
                    href="https://www.facebook.com/NBRC.org/"
                    class="fa fa-facebook"
                    target="_blank"
                ></a>
                <a
                    href="https://www.linkedin.com/company/national-board-for-respiratory-care/"
                    class="fa fa-linkedin"
                    target="_blank"
                ></a>
                <a
                    href="https://www.youtube.com/channel/UCeKW6Wrrjtg-ZGz5EUMRk0g/featured?view_as=subscriber"
                    class="fa fa-youtube"
                    target="_blank"
                ></a>
                <a
                    href="https://www.instagram.com/the_nbrc/"
                    class="fa fa-instagram"
                    target="_blank"
                ></a>

                <a
                    href="tel:9138954900"
                    class="toolbar__link contact__item"
                >
                    913.895.4900
                </a>
                <a
                    href="email:info@nbrc.org"
                    class="toolbar__link contact__item"
                >
                    info@nbrc.org
                </a>
            </div>
            <!-- <div *ngIf="isShowChat === true && isLiveChatWidgetLoaded === true">
				 <input type="image" src="/assets/images/Website chat button.png" (click)="openChatWindow()" />
			</div>
			<div *ngIf="isShowChat === true && isLiveChatWidgetLoaded === false">
				<div data-id="8e6afb82a3" class="livechat_button">
					<a href="https://www.livechat.com/customer-service/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_12112842"> 
						Chat
					</a>
			   </div>
		   </div> -->
            <input
                *ngIf="showChat() && !agentsAvailable"
                type="image"
                src="/assets/images/Website leave a message button.png"
                (click)="openChatWindow()"
            >
            <input
                *ngIf="showChat() && agentsAvailable"
                type="image"
                src="/assets/images/Website chat button.png"
                (click)="openChatWindow()"
            >
            <!-- <div data-id="Veg0u1vtw0-" class="livechat_button">
                <a href="https://www.livechat.com/customer-service/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_12112842">
                    Contact Customer Care
                </a>
            </div> -->
        </div>
    </div>
    <div class="page-width site-header__inner-wrap">
        <a
            routerLink
            class="logo-link"
            *ngIf="!isAssessment && !isDirectory"
        >
            <img
                src="/assets/images/logo.png"
                class="logo"
                alt="NBRC logo"
            >
        </a>
        <a
            href="https://nbrc.org"
            class="logo-link"
            *ngIf="!isAssessment && isDirectory"
        >
            <img
                src="/assets/images/logo.png"
                class="logo"
                alt="NBRC logo"
            >
        </a>
        <div class="logo-wrap">
            <img
                src="/assets/images/logo.png"
                class="logo"
                alt="NBRC logo"
                *ngIf="isAssessment"
            >
            <p
                style="color:red"
                *ngIf="AlphaOrBeta()"
            >
                {{instance}} Instance
            </p>
        </div>
        <div
            class="current-user site-header__current-user"
            *ngIf="username && !isAssessment"
        >
            <div class="current-user__item">
                Welcome,
                <strong class="current-user__name">{{username}}</strong>
            </div>
            <div
                class="current-user__item current-user__title"
                *ngIf="isCredentialed && !isUnderNBRCJE"
            >
                Credentialed Practitioner
                <i class="icon icon--check-circle"></i>
            </div>
            <div class="current-user__item">
                <a
                    routerLink="practitioner/profile/edit"
                    class="current-user__link"
                    href="#"
                >
                    My Account
                </a>
            </div>
            <div
                class="current-user__item current-user__cart"
                *ngIf="isCredentialed && !isUnderNBRCJE"
            >
                <a
                    routerLink="purchase/checkout"
                    class="current-user__link current-user__link--cart"
                >
                    <span class="cart-item-indicator">{{itemCount}}</span>
                    <span class="icon icon--shopping-cart"></span>
                    <span>Cart</span>
                </a>
            </div>
        </div>

    </div>
</header>
